import React, { Component } from "react";
import NavBottom from "../../base/features/blocks/NavBottom";
import { Link } from "react-router-dom";
import { FiChevronDown, FiChevronLeft, FiSettings } from "react-icons/fi";
import { profileDetail } from "./services";
import Spinner from "../../base/features/micro/Spinner";
import AccountsModal from "../../base/features/blocks/AccountsModal";
import { accounts } from "../../base/services/services";
import Image from "../../base/features/micro/Image";
import { BiCustomize } from "react-icons/bi";
import { fixObject } from "../../base/utils/convert_to_object";
import { isSiteDomain } from "../../settings/domainManager";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      accounts_modal: false,
      accounts: null,
    };
  }
  componentDidMount() {
    this.get_profile_detail();
    this.checkAccountsModal();
  }
  checkAccountsModal() {
    let accounts =
      window.location.search && fixObject(window.location.search).accounts;
    if (accounts && Number(accounts) === 1) {
      this.setState({ accounts_modal: true });
      this.get_accounts();
    }
  }
  get_profile_detail() {
    profileDetail().then((items) => {
      items &&
        this.setState({
          user: items,
        });
    });
  }
  get_accounts() {
    accounts().then((items) => {
      items &&
        this.setState({
          accounts: items.shops,
          user: items.user,
        });
    });
  }
  render() {
    return (
      <div className="container-fluid px-0">
        {!isSiteDomain && <NavBottom />}
        <header className="row mx-0 px-3 py-3">
          <div className="col align-self-center">
            <Link
              to={{
                pathname: "/editProfile",
                state: this.state.user && { user: this.state.user },
              }}
            >
              <span className="color-main fw-bold">ویرایش حساب کاربری</span>
            </Link>
          </div>
          <div className="col-auto align-self-center">
            <Link
              to={{
                pathname: "/setting",
              }}
            >
              <FiSettings size="28" />
            </Link>
          </div>
        </header>
        {this.state.user ? (
          <body>
            <div className="row mx-0 px-3 py-3">
              <div className="col-auto align-self-center">
                <Image
                  imageUri={this.state.user.image && this.state.user.image}
                  isProfile={true}
                  imageHeight={"70"}
                  imageWidth={"70"}
                  imgClassName={"rounded-circle img-cover"}
                  extraClassName={"p-0 img-contain rounded-0"}
                />
              </div>
              <div className="col align-self-center px-1">
                <p
                  className="mb-0 fs-3 fw-bold"
                  onClick={() => {
                    this.setState({ accounts_modal: true });
                    this.get_accounts();
                  }}
                >
                  {this.state.user.first_name}
                  <FiChevronDown size={26} className="me-2" />
                </p>
                <p className="mb-0 text-muted fw-bold">
                  {this.state.user.phone}
                </p>
              </div>
            </div>
            <div className="px-4">
              <Link to="/orders">
                <div className="row mx-0 border rounded14 p-4">
                  <div className="col-auto px-0">
                    <img
                      src={require("./icons/cart.svg").default}
                      className=""
                      alt="cart"
                      width="28"
                    />
                  </div>

                  <div className="col">
                    <span className="fw-bold fs-5">سفارش های من</span>
                  </div>
                  <div className="col-auto px-0">
                    <FiChevronLeft size="28" />
                  </div>
                </div>
              </Link>

              <Link to="/addresses">
                <div className="row mt-3 mx-0 border rounded14 p-4">
                  <div className="col-auto px-0">
                    <img
                      src={require("./icons/location.svg").default}
                      className=""
                      alt="cart"
                      width="28"
                    />
                  </div>

                  <div className="col">
                    <span className="fw-bold fs-5">آدرس های من</span>
                  </div>
                  <div className="col-auto px-0">
                    <FiChevronLeft size="26" />
                  </div>
                </div>
              </Link>
              <Link to="/custom-products">
                <div className="row mt-3 mx-0 border rounded14 p-4">
                  <div className="col-auto px-0">
                    <BiCustomize size="28" />
                  </div>

                  <div className="col">
                    <span className="fw-bold fs-5">محصولات سفارشی</span>
                  </div>
                  <div className="col-auto px-0">
                    <FiChevronLeft size="26" />
                  </div>
                </div>
              </Link>
            </div>
          </body>
        ) : (
          <Spinner />
        )}

        {this.state.accounts_modal && (
          <AccountsModal
            changeModal={(value) => this.setState({ accounts_modal: value })}
            accounts_modal={this.state.accounts_modal}
            accounts={this.state.accounts}
            user={this.state.user}
          />
        )}
      </div>
    );
  }
}

export default Profile;
